<div class="remote-device-status-icons pull-right">
    <i class="fa fa-circle {{#if lightClass}}{{lightClass}}{{else}}{{#COMPARE light '==' 1}}success{{else}}{{/COMPARE}}{{/if}}"></i>
    <i class="fa fa-circle {{#if lightClass}}{{lightClass}}{{else}}{{#COMPARE light '==' 0}}success{{else}}{{/COMPARE}}{{/if}}"></i>
</div>
{{#if spectatorCount}}
<div class="pull-right m-t-10 m-l-10">
    <i class="fa fa-eye">
    </i>
    <span class="badge badge-xs">{{spectatorCount}}</span>
</div>
{{/if}}
<div class="pull-right m-t-10">
    <span class="label label-default js-lbl-status hidden-xs {{statusClass}}">{{statusText}}</span>
</div>
